import { render } from "./FormDocument.vue?vue&type=template&id=0ca02bf9&scoped=true"
import script from "./FormDocument.vue?vue&type=script&lang=js"
export * from "./FormDocument.vue?vue&type=script&lang=js"

import "./FormDocument.vue?vue&type=style&index=0&id=0ca02bf9&scoped=true&lang=css"

import exportComponent from "D:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca02bf9"]])

export default __exports__